import type { FaireProductEntity } from "../../entity_types/product";

export const p_y3q54auwb9: FaireProductEntity = {
  token: "p_y3q54auwb9",
  type: "product",
  name: "Sunday Pasta Matchbook",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/4cb416981c6a9f2c49de77da47085c8735009c2d2c47a16c9e5a15d7079f89bd.png",
  galleryImageUrls: [],
  priceDollars: 3,
  description: "A matchbook perfect for celebrating, lighting candles, setting the vibes in your home, office, or on the go. This matchbook features 10 matches, each printed with an ingredient or icon, and blue strike heads to match. \n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:09.500Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
